export default __webpack_public_path__ + "static/equipment-b101a0088b7b69c1612d8ae677e5443f.svg";